import React, { createContext, useContext, useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Icon from '../AppIcon';

const SidebarContext = createContext();

export const SidebarProvider = ({ children }) => {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);

  useEffect(() => {
    const savedState = localStorage.getItem('sidebar-collapsed');
    if (savedState !== null) {
      setIsCollapsed(JSON.parse(savedState));
    }
  }, []);

  const toggleCollapse = () => {
    const newState = !isCollapsed;
    setIsCollapsed(newState);
    localStorage.setItem('sidebar-collapsed', JSON.stringify(newState));
  };

  const toggleMobile = () => {
    setIsMobileOpen(!isMobileOpen);
  };

  const closeMobile = () => {
    setIsMobileOpen(false);
  };

  return (
    <SidebarContext.Provider
      value={{
        isCollapsed,
        isMobileOpen,
        toggleCollapse,
        toggleMobile,
        closeMobile
      }}>
      {children}
    </SidebarContext.Provider>
  );

};

export const useSidebar = () => {
  const context = useContext(SidebarContext);
  if (!context) {
    throw new Error('useSidebar must be used within SidebarProvider');
  }
  return context;
};

const Sidebar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { isCollapsed, isMobileOpen, toggleCollapse, toggleMobile, closeMobile } = useSidebar();

  const navigationItems = [
  {
    label: 'Dashboard',
    path: '/dashboard',
    icon: 'LayoutDashboard'
  },
  {
    label: 'Events',
    path: '/event-management',
    icon: 'Calendar'
  },
  {
    label: 'Users',
    path: '/user-management',
    icon: 'Users'
  }];


  const handleNavigation = (path) => {
    navigate(path);
    closeMobile();
  };

  const isActive = (path) => {
    return location?.pathname === path;
  };

  useEffect(() => {
    if (isMobileOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isMobileOpen]);

  return (
    <>
      {isMobileOpen &&
      <div
        className="mobile-overlay"
        onClick={closeMobile}
        aria-hidden="true" />

      }
      <aside
        className={`sidebar ${isCollapsed ? 'collapsed' : ''} ${
        isMobileOpen ? 'translate-x-0' : '-translate-x-full'} lg:translate-x-0`
        }>

        <div className="sidebar-header py-[21px]">
          <div className="sidebar-logo">
            <Icon name="Rocket" size={24} color="#FF6B2C" />
          </div>
          <span className="sidebar-brand-text" style={{color: '#FF6B2C', fontWeight: 700}}>KidQuest</span>
        </div>

        <nav className="sidebar-nav">
          {navigationItems?.map((item) =>
          <div
            key={item?.path}
            onClick={() => handleNavigation(item?.path)}
            className={`sidebar-nav-item ${
            isActive(item?.path) ? 'active' : ''}`
            }
            style={isActive(item?.path) ? {
              backgroundColor: '#FFF0E8',
              color: '#FF6B2C',
              borderLeft: '3px solid #FF6B2C',
              paddingLeft: '9px'
            } : {}}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {
              if (e?.key === 'Enter' || e?.key === ' ') {
                e?.preventDefault();
                handleNavigation(item?.path);
              }
            }}>

              <Icon name={item?.icon} size={20} />
              <span className="sidebar-nav-item-text">{item?.label}</span>
            </div>
          )}
        </nav>
      </aside>
    </>);

};

export default Sidebar;